import React from "react";
import { motion } from "framer-motion";

const CITIES = ["Srinagar", "Delhi", "Bangalore", "Mumbai", "Guwahati"];

const MARQUEE = [...CITIES, ...CITIES, ...CITIES];

export const Vision = () => {
    return (
        <section
            id="vision"
            data-testid="vision-section"
            className="relative bg-tip-black text-white py-24 md:py-36 overflow-hidden"
        >
            <div className="absolute inset-0 grain opacity-40" />

            {/* Outline marquee */}
            <div className="absolute inset-x-0 top-10 md:top-16 pointer-events-none select-none">
                <div className="marquee-track">
                    {MARQUEE.map((c, i) => (
                        <span
                            key={`mq-${i}`}
                            className="outline-text text-[18vw] md:text-[14vw] px-8 whitespace-nowrap text-white"
                        >
                            {c} —
                        </span>
                    ))}
                </div>
            </div>

            <div className="tip-container relative pt-[18vw] md:pt-[14vw]">
                <div className="grid lg:grid-cols-12 gap-10 items-end">
                    <div className="lg:col-span-7">
                        <div className="eyebrow text-white/60 mb-6">
                            04 — Our Vision
                        </div>
                        <motion.h2
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.4 }}
                            transition={{ duration: 0.8 }}
                            className="font-display font-black text-4xl sm:text-5xl md:text-6xl lg:text-[88px] leading-[0.95] tracking-[-0.035em]"
                        >
                            From{" "}
                            <span className="text-tip-saffron">Kashmir</span>{" "}
                            to{" "}
                            <span className="text-white">Kanyakumari,</span>
                            <br />
                            <span className="text-tip-saffron">Gujarat</span>{" "}
                            to{" "}
                            <span className="text-tip-green italic">
                                Arunachal.
                            </span>
                        </motion.h2>
                    </div>
                    <div className="lg:col-span-5 lg:pl-10 lg:border-l border-white/15">
                        <p className="text-white/75 text-lg leading-relaxed">
                            We&apos;re building India&apos;s most ambitious
                            cultural project — travelling city by city, language
                            by language, until every Indian sees themselves
                            represented in the national conversation.
                        </p>
                        <p className="mt-5 text-white/55 text-sm">
                            Subtitled. Translated. Free to watch. Always.
                        </p>
                    </div>
                </div>

                <div
                    data-testid="cities-grid"
                    className="mt-20 grid grid-cols-2 md:grid-cols-5 gap-px border border-white/15 bg-white/15"
                >
                    {CITIES.map((c, i) => (
                        <div
                            key={c}
                            data-testid={`city-${c.toLowerCase()}`}
                            className="bg-tip-black p-6 md:p-7 group hover:bg-white hover:text-tip-black transition-colors duration-500 cursor-default"
                        >
                            <div className="text-xs tracking-[0.2em] uppercase opacity-60">
                                0{i + 1}
                            </div>
                            <div className="mt-3 font-display font-bold text-2xl md:text-[28px] leading-tight">
                                {c}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
